(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  var $cJzMp = parcelRequire("cJzMp");
  var $c15ba6bb858367ff$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("slider-controls")) return;
    customElements.define("slider-controls", class SliderControls extends HTMLElement {
      static get observedAttributes() {
        return [ "data-slider-target", "data-slider-targets" ];
      }
      constructor() {
        super();
        this._rawLogger = (0, $cJzMp.createLogger)("slider-controls");
        this.isDebugLogEnabled = false;
        this.slider = null;
        this.sliders = [];
        this.sliderStates = new WeakMap;
        this.prev = null;
        this.next = null;
        this._activityObserver = null;
        this._onPrevClick = this._onPrevClick.bind(this);
        this._onNextClick = this._onNextClick.bind(this);
        this._onSliderState = this._onSliderState.bind(this);
        this._onRefresh = this._onRefresh.bind(this);
      }
      log(topic, message, detail) {
        if (this.isDebugLogEnabled) this._rawLogger(topic, message, detail);
      }
      connectedCallback() {
        this.isDebugLogEnabled = this.hasAttribute("data-debug-enabled");
        this.prev = this.querySelector("[data-previous]");
        this.next = this.querySelector("[data-next]");
        this.log("lifecycle", "connected", {
          sliderTarget: this.dataset.sliderTarget || null,
          sliderTargets: this.dataset.sliderTargets || null
        });
        this.prev?.addEventListener("click", this._onPrevClick);
        this.next?.addEventListener("click", this._onNextClick);
        this.addEventListener("slider-controls:refresh", this._onRefresh);
        this._bindTargetSliders();
      }
      disconnectedCallback() {
        this.prev?.removeEventListener("click", this._onPrevClick);
        this.next?.removeEventListener("click", this._onNextClick);
        this.removeEventListener("slider-controls:refresh", this._onRefresh);
        this._unbindTargetSliders();
      }
      _onPrevClick() {
        const activeSlider = this._getActiveSlider();
        if (!activeSlider) return;
        this.log("events", "previous click", {
          activeSlider: activeSlider.dataset.sliderId || null
        });
        activeSlider.dispatchEvent(new CustomEvent("slider:previous"));
      }
      _onNextClick() {
        const activeSlider = this._getActiveSlider();
        if (!activeSlider) return;
        this.log("events", "next click", {
          activeSlider: activeSlider.dataset.sliderId || null
        });
        activeSlider.dispatchEvent(new CustomEvent("slider:next"));
      }
      _onSliderState(event) {
        const slider = event.currentTarget;
        const detail = event.detail || {};
        this.sliderStates.set(slider, detail);
        this.log("events", "slider state event", {
          sourceSlider: slider?.dataset?.sliderId || null,
          controlsVisible: detail.controlsVisible,
          canGoPrev: detail.canGoPrev,
          canGoNext: detail.canGoNext
        });
        if (slider !== this._getActiveSlider()) return;
        this._applyState(detail);
      }
      _onRefresh() {
        this._bindTargetSliders();
      }
      refreshState() {
        this._syncActiveSliderState();
      }
      _applyState(detail = {}) {
        let controlsVisible = detail.controlsVisible === true;
        const canGoPrev = controlsVisible && detail.canGoPrev === true;
        const canGoNext = controlsVisible && detail.canGoNext === true;
        if (!canGoPrev && !canGoNext) controlsVisible = false;
        this.log("ui", "apply controls state", {
          activeSlider: this.slider?.dataset?.sliderId || null,
          controlsVisible: controlsVisible,
          canGoPrev: canGoPrev,
          canGoNext: canGoNext
        });
        const updateAriaHidden = (el, isVisible) => {
          if (!el) return;
          const val = isVisible ? "false" : "true";
          if (el.getAttribute("aria-hidden") !== val) el.setAttribute("aria-hidden", val);
        };
        updateAriaHidden(this, controlsVisible);
        if (this.prev) {
          if (this.prev.hasAttribute("disabled") === canGoPrev) this.prev.toggleAttribute("disabled", !canGoPrev);
          updateAriaHidden(this.prev, canGoPrev);
        }
        if (this.next) {
          if (this.next.hasAttribute("disabled") === canGoNext) this.next.toggleAttribute("disabled", !canGoNext);
          updateAriaHidden(this.next, canGoNext);
        }
      }
      _bindTargetSliders() {
        this._unbindTargetSliders();
        this.sliders = this._resolveTargetSliders();
        this.log("lifecycle", "bind target sliders", {
          count: this.sliders.length,
          ids: this.sliders.map(slider => slider.dataset.sliderId || null)
        });
        if (!this.sliders.length) {
          this._applyState();
          return;
        }
        this.sliders.forEach(slider => {
          slider.addEventListener("slider:init", this._onSliderState);
          slider.addEventListener("slider:change", this._onSliderState);
          slider.addEventListener("slider:controls-state", this._onSliderState);
        });
        this._syncActiveSliderState();
      }
      _unbindTargetSliders() {
        this.sliders.forEach(slider => {
          slider.removeEventListener("slider:init", this._onSliderState);
          slider.removeEventListener("slider:change", this._onSliderState);
          slider.removeEventListener("slider:controls-state", this._onSliderState);
        });
        this.sliders = [];
        this.slider = null;
        this._applyState();
      }
      _resolveTargetSliders() {
        const scope = this.closest(".shopify-section") || document;
        const explicitTargets = (this.dataset.sliderTargets || "").split(",").map(value => value.trim()).filter(Boolean);
        if (explicitTargets.length) return explicitTargets.map(targetId => scope.querySelector(`slider-component[data-slider-id="${targetId}"]`)).filter(Boolean);
        const explicitTarget = this.dataset.sliderTarget;
        if (explicitTarget) {
          const slider = scope.querySelector(`slider-component[data-slider-id="${explicitTarget}"]`);
          return slider ? [ slider ] : [];
        }
        const parentSlider = this.closest("slider-component");
        return parentSlider ? [ parentSlider ] : [];
      }
      _getActiveSlider() {
        if (!this.sliders.length) return null;
        if (this.dataset.sliderTarget) {
          const exact = this.sliders.find(slider => slider.dataset.sliderId === this.dataset.sliderTarget);
          return exact || this.sliders[0];
        }
        const flaggedSlider = this.sliders.find(slider => slider.dataset.rpActiveSlider === "true");
        if (flaggedSlider) return flaggedSlider;
        const visiblePanelSlider = this.sliders.find(slider => {
          const panel = slider.closest("[data-rp-panel]");
          return panel ? panel.getAttribute("aria-hidden") !== "true" : true;
        });
        return visiblePanelSlider || this.sliders[0];
      }
      _syncActiveSliderState() {
        this.slider = this._getActiveSlider();
        this.log("lifecycle", "sync active slider", {
          activeSlider: this.slider?.dataset?.sliderId || null,
          available: this.sliders.map(slider => slider.dataset.sliderId || null)
        });
        if (!this.slider) {
          this._applyState();
          return;
        }
        const knownState = this.sliderStates.get(this.slider);
        if (knownState) this._applyState(knownState);
        const activeSlider = this.slider;
        activeSlider.dispatchEvent(new CustomEvent("slider:get-state", {
          detail: {
            callback: state => {
              const nextState = state || {};
              this.sliderStates.set(activeSlider, nextState);
              if (this.slider === activeSlider) this._applyState(nextState);
            }
          }
        }));
      }
    });
  })();
})();